import { Component } from '@angular/core';
import { LoadingService } from '../services/loading.service';
import { ThemeService } from '../services/theme.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss',
    standalone: false
})
export class AppComponent {

  constructor(public loadingService: LoadingService, themeService: ThemeService) {
    themeService.init();
  }

}
